import React, { ReactNode } from "react";
import {
  AccordionItem,
  Accordion,
  AccordionTrigger,
  AccordionContent,
  AccordionProps,
} from "@/components/ui/accordion";
import { asArray, cn, isDefined, render, Renderable } from "@/lib/utils";
import { AccordionItemProps } from "@radix-ui/react-accordion";
import { cva, VariantProps } from "class-variance-authority";
import _ from "lodash";

const cellStyles = cva("_cell overflow-hidden overflow-ellipsis", {
  variants: {
    variant: { default: "", clear: "" },
  },
  defaultVariants: { variant: "default" },
});
const labelStyles = cva("_label", {
  variants: {
    variant: { default: "text-start", clear: "" },
  },
  defaultVariants: { variant: "default" },
});
const valueStyles = cva("_value", {
  variants: {
    variant: { default: "", clear: "" },
  },
  defaultVariants: { variant: "default" },
});
const rowStyles = cva("_row", {
  variants: {
    variant: { default: "", clear: "" },
  },
  defaultVariants: {
    variant: "default",
  },
});
const accordionWrapStyles = cva("_accordion_wrap", {
  variants: {
    variant: { default: "", clear: "" },
    invert: { true: "", false: "" },
    isEven: { true: "", false: "" },
    isEvenDepth: { true: "", false: "" },
    siblingsAreAccordions: { true: "", false: "" },
  },
  defaultVariants: {
    variant: "default",
    invert: false,
    isEven: false,
    isEvenDepth: false,
    siblingsAreAccordions: false,
  },
  compoundVariants: [
    {
      variant: "default",
      invert: false,
      isEvenDepth: true,
      isEven: false,
      siblingsAreAccordions: false,
      class:
        "!bg-accent [&>*:nth-child(odd)]:!bg-background [&>*:nth-child(even)]:!bg-accent", // PORTS INVERTED OK
    },
    {
      variant: "default",
      invert: false,
      isEvenDepth: false,
      isEven: false,
      siblingsAreAccordions: false,
      class:
        "!bg-accent [&>*:nth-child(odd)]:!bg-background [&>*:nth-child(even)]:!bg-accent",
    },
    {
      variant: "default",
      invert: false,
      isEvenDepth: true,
      isEven: true,
      siblingsAreAccordions: false,
      class:
        "!bg-background [&>*:nth-child(odd)]:!bg-accent [&>*:nth-child(even)]:!bg-background", // OS INVERTED | MODELS NORMAL
    },
    {
      variant: "default",
      invert: false,
      isEvenDepth: false,
      isEven: true,
      siblingsAreAccordions: false,
      class:
        "!bg-background [&>*:nth-child(odd)]:!bg-accent [&>*:nth-child(even)]:!bg-background",
    },

    {
      variant: "default",
      invert: true,
      isEvenDepth: true,
      isEven: false,
      siblingsAreAccordions: false,
      class:
        "!bg-background [&>*:nth-child(odd)]:!bg-accent [&>*:nth-child(even)]:!bg-background",
    },
    {
      variant: "default",
      invert: true,
      isEvenDepth: false,
      isEven: false,
      siblingsAreAccordions: false,
      class:
        // "!bg-accent [&>*:nth-child(odd)]:!bg-background [&>*:nth-child(even)]:!bg-accent",
        "!bg-background [&>*:nth-child(odd)]:!bg-accent [&>*:nth-child(even)]:!bg-background",
    },
    {
      variant: "default",
      invert: true,
      isEvenDepth: true,
      isEven: true,
      siblingsAreAccordions: false,
      class:
        "!bg-accent [&>*:nth-child(odd)]:!bg-background [&>*:nth-child(even)]:!bg-accent",
    },
    {
      variant: "default",
      invert: true,
      isEvenDepth: false,
      isEven: true,
      siblingsAreAccordions: false,
      class:
        // "!bg-background [&>*:nth-child(odd)]:!bg-accent [&>*:nth-child(even)]:!bg-background",
        "!bg-accent [&>*:nth-child(odd)]:!bg-background [&>*:nth-child(even)]:!bg-accent",
      // "!bg-accent [&>*:nth-child(odd)]:!bg-accent [&>*:nth-child(even)]:!bg-background",
    },

    //////////////

    // {
    //   variant: "default",
    //   invert: false,
    //   isEvenDepth: true,
    //   isEven: false,
    //   siblingsAreAccordions: true,
    //   class:
    //     // "!bg-accent [&>*:nth-child(odd)]:!bg-background [&>*:nth-child(even)]:!bg-accent",
    // },
    // {
    //   variant: "default",
    //   invert: false,
    //   isEvenDepth: false,
    //   isEven: false,
    //   siblingsAreAccordions: true,
    //   class:
    //     "!bg-accent [&>*:nth-child(odd)]:!bg-accent [&>*:nth-child(even)]:!bg-background",
    // },
    // {
    //   variant: "default",
    //   invert: false,
    //   isEvenDepth: true,
    //   isEven: true,
    //   siblingsAreAccordions: true,
    //   class:
    //     "!bg-background [&>*:nth-child(odd)]:!bg-accent [&>*:nth-child(even)]:!bg-background",
    // },
    // {
    //   variant: "default",
    //   invert: false,
    //   isEvenDepth: false,
    //   isEven: true,
    //   siblingsAreAccordions: true,
    //   class:
    //     "!bg-accent [&>*:nth-child(odd)]:!bg-background [&>*:nth-child(even)]:!bg-accent",
    // },

    // {
    //   variant: "default",
    //   invert: true,
    //   isEvenDepth: true,
    //   isEven: false,
    //   siblingsAreAccordions: true,
    //   class:
    //     "!bg-background [&>*:nth-child(odd)]:!bg-accent [&>*:nth-child(even)]:!bg-background",
    // },
    // {
    //   variant: "default",
    //   invert: true,
    //   isEvenDepth: false,
    //   isEven: false,
    //   siblingsAreAccordions: true,
    //   class:
    //     "!bg-background [&>*:nth-child(odd)]:!bg-background [&>*:nth-child(even)]:!bg-accent",
    // },
    // {
    //   variant: "default",
    //   invert: true,
    //   isEvenDepth: true,
    //   isEven: true,
    //   siblingsAreAccordions: true,
    //   class:
    //     // "!bg-accent [&>*:nth-child(odd)]:!bg-background [&>*:nth-child(even)]:!bg-accent",
    // },
    // {
    //   variant: "default",
    //   invert: true,
    //   isEvenDepth: false,
    //   isEven: true,
    //   siblingsAreAccordions: true,
    //   class:
    //     "!bg-background [&>*:nth-child(odd)]:!bg-accent [&>*:nth-child(even)]:!bg-background",
    // },
  ],
});
const accordionStyles = cva("_accordion grid", {
  variants: {
    variant: { default: "", clear: "" },
    invert: { true: "", false: "" },
    siblingsAreAccordions: { true: "", false: "" },
    hasParent: { true: "", false: "" },
    isEven: { true: "", false: "" },
    isEvenDepth: { true: "", false: "" },
    spacing: { default: "" },
    border: { true: "border", false: "" },
    showOverflow: { true: "", false: "overflow-hidden" },
  },
  defaultVariants: {
    variant: "default",
    invert: false,
    siblingsAreAccordions: false,
    hasParent: false,
    isEven: false,
    isEvenDepth: false,
    spacing: "default",
    border: true,
    showOverflow: false,
  },
  compoundVariants: [
    {
      variant: "default",
      invert: false,
      isEvenDepth: true,
      isEven: false,
      siblingsAreAccordions: false,
      class:
        "bg-background [&>*:nth-child(odd)]:bg-background [&>*:nth-child(even)]:bg-accent",
    },
    {
      variant: "default",
      invert: false,
      isEvenDepth: false,
      isEven: false,
      siblingsAreAccordions: false,
      class:
        "bg-background [&>*:nth-child(odd)]:bg-background [&>*:nth-child(even)]:bg-accent",
      // "bg-background [&>*:nth-child(odd)]:bg-accent [&>*:nth-child(even)]:bg-background",
      // "bg-red-600",
    },
    {
      variant: "default",
      invert: false,
      isEvenDepth: true,
      isEven: true,
      siblingsAreAccordions: false,
      class:
        "bg-background [&>*:nth-child(odd)]:bg-accent [&>*:nth-child(even)]:bg-background",
    },
    {
      variant: "default",
      invert: false,
      isEvenDepth: false,
      isEven: true,
      siblingsAreAccordions: false,
      class:
        // "bg-accent [&>*:nth-child(odd)]:bg-accent [&>*:nth-child(even)]:bg-background",
        "bg-accent [&>*:nth-child(odd)]:bg-background [&>*:nth-child(even)]:bg-accent", // 1
    },

    {
      variant: "default",
      invert: true,
      isEvenDepth: true,
      isEven: false,
      siblingsAreAccordions: false,
      class:
        // "bg-accent [&>*:nth-child(odd)]:bg-accent [&>*:nth-child(even)]:bg-background", // 1?
        "bg-accent [&>*:nth-child(odd)]:bg-background [&>*:nth-child(even)]:bg-accent", // 1
    },
    {
      variant: "default",
      invert: true,
      isEvenDepth: false,
      isEven: false,
      siblingsAreAccordions: false,
      class:
        "bg-accent [&>*:nth-child(odd)]:bg-background [&>*:nth-child(even)]:bg-accent", // 1
      // "bg-accent [&>*:nth-child(odd)]:bg-accent [&>*:nth-child(even)]:bg-background", // 1
    },
    {
      variant: "default",
      invert: true,
      isEvenDepth: true,
      isEven: true,
      siblingsAreAccordions: false,
      class:
        "bg-accent [&>*:nth-child(odd)]:bg-background [&>*:nth-child(even)]:bg-accent",
    },
    {
      variant: "default",
      invert: true,
      isEvenDepth: false,
      isEven: true,
      siblingsAreAccordions: false,
      class:
        // "bg-background [&>*:nth-child(odd)]:bg-background [&>*:nth-child(even)]:bg-accent", // 1
        "bg-background [&>*:nth-child(odd)]:bg-accent [&>*:nth-child(even)]:bg-background", // 1
    },

    ////////////////

    {
      variant: "default",
      invert: false,
      isEvenDepth: true,
      isEven: false,
      siblingsAreAccordions: true,
      class:
        "bg-background [&>*:nth-child(odd)]:bg-background [&>*:nth-child(even)]:bg-accent",
    },
    {
      variant: "default",
      invert: false,
      isEvenDepth: false,
      isEven: false,
      siblingsAreAccordions: true,
      class:
        "bg-background [&>*:nth-child(odd)]:bg-background [&>*:nth-child(even)]:bg-accent",
    },
    {
      variant: "default",
      invert: false,
      isEvenDepth: true,
      isEven: true,
      siblingsAreAccordions: true,
      class:
        "bg-background [&>*:nth-child(odd)]:bg-accent [&>*:nth-child(even)]:bg-background",
    },
    {
      variant: "default",
      invert: false,
      isEvenDepth: false,
      isEven: true,
      siblingsAreAccordions: true,
      class:
        "bg-accent [&>*:nth-child(odd)]:bg-accent [&>*:nth-child(even)]:bg-background",
    },

    {
      variant: "default",
      invert: true,
      isEvenDepth: true,
      isEven: false,
      siblingsAreAccordions: true,
      class:
        "bg-accent [&>*:nth-child(odd)]:bg-accent [&>*:nth-child(even)]:bg-background",
    },
    {
      variant: "default",
      invert: true,
      isEvenDepth: false,
      isEven: false,
      siblingsAreAccordions: true,
      class:
        "bg-accent [&>*:nth-child(odd)]:bg-accent [&>*:nth-child(even)]:bg-background",
    },
    {
      variant: "default",
      invert: true,
      isEvenDepth: true,
      isEven: true,
      siblingsAreAccordions: true,
      class:
        "bg-accent [&>*:nth-child(odd)]:bg-accent [&>*:nth-child(even)]:bg-background",
    },
    {
      variant: "default",
      invert: true,
      isEvenDepth: false,
      isEven: true,
      siblingsAreAccordions: true,
      class:
        "bg-background [&>*:nth-child(odd)]:bg-background [&>*:nth-child(even)]:bg-accent",
    },

    {
      hasParent: true,
      class: "grid-rows-subgrid",
    },
    {
      hasParent: false,
      class: "grid-rows-[repeat(auto-fit,1fr)]",
    },
    {
      spacing: "default",
      hasParent: false,
      class: "rounded-lg",
    },
    {
      spacing: "default",
      hasParent: true,
      class: "rounded-b-lg",
    },
    {
      variant: "default",
      border: true,
      invert: false,
      class: "border-muted",
    },
    {
      variant: "default",
      border: true,
      invert: true,
      class: "border-border",
    },
  ],
});
const accordionRowsStyles = cva("_accordion_rows grid grid-rows-subgrid", {
  variants: {
    variant: { default: "", clear: "" },
    spacing: { default: "p-2 gap-2" },
    itemsInRows: { auto: "grid-cols-auto", 2: "", 3: "" },
    hasAccordions: {
      true: "",
      false: "",
    },
  },
  defaultVariants: {
    variant: "default",
    spacing: "default",
    itemsInRows: "auto",
    hasAccordions: false,
  },
  compoundVariants: [
    {
      spacing: "default",
      itemsInRows: 2,
      class: "grid-cols-[minmax(100px,1fr)_minmax(100px,1.5fr)]",
    },
    {
      spacing: "default",
      itemsInRows: 3,
      class:
        "grid-cols-[minmax(100px,1fr)_minmax(100px,1fr)_minmax(100px,1fr)]",
    },
    {
      spacing: "default",
      hasAccordions: true,
      class: "px-4",
    },
  ],
});
const accordionItemStyles = cva("_accordion_item", {
  variants: {
    variant: { default: "", clear: "" },
    hasParent: { true: "grid-rows-subgrid", false: "" },
    spacing: { default: "w-full grid p-2" },
  },
  defaultVariants: {
    variant: "default",
    hasParent: false,
    spacing: "default",
  },
});
const nestedAccordionItemStyles = cva("_nested_accordion_item", {
  variants: {
    variant: { default: "", clear: "" },
    invert: { true: "", false: "" },
    reinvert: { true: "", false: "" },
    // isEven: { true: "", false: "" },
    border: { true: "border rounded-lg", false: "" },
    spacing: { default: "mx-2" },
    first: { true: "", false: "" },
    last: { true: "", false: "" },
    prevIsAccordion: {
      true: "",
      false: "",
    },
    nextIsAccordion: {
      true: "",
      false: "",
    },
  },
  compoundVariants: [
    {
      spacing: "default",
      first: true,
      // isEven: true,
      class: "mt-2",
    },
    {
      spacing: "default",
      prevIsAccordion: true,
      class: "mt-1",
    },
    {
      spacing: "default",
      nextIsAccordion: true,
      class: "mb-1",
    },
    { spacing: "default", last: true, class: "mb-2" },
    {
      variant: "default",
      border: true,
      invert: false,
      class: "border-muted",
    },
    {
      variant: "default",
      border: true,
      invert: true,
      class: "border-border",
    },
  ],
  defaultVariants: {
    variant: "default",
    invert: false,
    // isEven: false,
    spacing: "default",
    border: true,
  },
});

export type Row = Omit<
  VariantProps<typeof labelStyles> &
    VariantProps<typeof valueStyles> &
    VariantProps<typeof cellStyles> &
    VariantProps<typeof rowStyles> &
    VariantProps<typeof accordionStyles> &
    VariantProps<typeof accordionItemStyles> &
    VariantProps<typeof nestedAccordionItemStyles>,
  "depth" | "itemsInRows"
> & {
  index?: number;
  displayIndex?: number;
  _key?: string | number;
  id?: string;
  path?: (string | number)[];
  depth?: number;
  itemsInRows?: number;
  parent?: Row;

  rowProps?: React.ComponentPropsWithRef<"div">;
  label?: Renderable;
  labelProps?: React.ComponentPropsWithRef<"div">;
  value?: Renderable;
  valueProps?: React.ComponentPropsWithRef<"div">;

  debug?: boolean;

  expandable?: boolean;
  content?: Renderable; // break out of Overview rendering
  rows?: Row[];

  accordionProps?: AccordionProps;
  accordionItemProps?: Omit<AccordionItemProps, "value"> &
    Partial<Pick<AccordionItemProps, "value">>;

  isEven?: boolean;
  isEvenDepth?: boolean;
  siblingsAreAccordions?: boolean;
  t?: (value?: any) => string;

  /**
   * Keep each row's subtree mounted across re-renders.
   *
   * Off by default, which preserves the long-standing behaviour: OverviewRows defines its row
   * wrapper inline, so it is a new component type on every render and React unmounts and remounts
   * every row's entire subtree each time. Any state inside a row - input values, focus, scroll
   * position, nested accordion open state - is therefore discarded on every re-render.
   *
   * That is a bug, but it has been the behaviour across every Overview in the app for long enough
   * that some page could plausibly depend on it, so switching it on is opt-in per Overview rather
   * than a silent change everywhere. Set it when a row contains something stateful that must
   * survive a re-render; see the metric-alert detail panel, whose cron calendar visibly closed and
   * reopened on every click because saving re-rendered the panel.
   *
   * Inherited by nested rows, since Overview spreads its props down.
   */
  preserveRowState?: boolean;
};

const globalIndex = (props: Row) => {
  let index = props.index ?? 0;
  let parent = props.parent;
  while (parent !== undefined) {
    index += (parent.index ?? 0) + 1;
    parent = parent?.parent;
  }
  return index;
};

const even = (props: Row) => {
  return globalIndex(props) % 2 == 0;
};

const evenDepth = (props: Row) => {
  return (props?.depth ?? 0) % 2 == 0;
};

function OverviewRowBase_(props: Row & { className?: string }) {
  const { parent, rowProps, label, labelProps, value, valueProps } = props;
  const t = props.t ?? ((a: any) => a as string);
  return (
    <div
      {...rowProps}
      className={rowStyles({
        ...props,
        className: cn(
          parent?.rowProps?.className,
          rowProps?.className,
          props.className,
        ),
      })}
    >
      {[
        ...(label || label === 0
          ? [typeof label == "string" ? t(label) || label : label].map(
              (cell) => ({
                cell,
                props: {
                  ...labelProps,
                  className: labelStyles({
                    ...props,
                    className: labelProps?.className,
                  }),
                },
              }),
            )
          : []),
        ...(asArray(value) ?? []).map((cell) => ({
          cell,
          props: {
            ...valueProps,
            className:
              Array.isArray(value) && value.length > 1
                ? cellStyles({ ...props, className: valueProps?.className })
                : valueStyles({ ...props, className: valueProps?.className }),
          },
        })),
      ].map(({ cell, props }, i) => (
        <div key={i} {...props}>
          {(typeof cell == "boolean"
            ? cell
              ? t("True")
              : t("False")
            : cell) ?? t("N/A")}
        </div>
      ))}
    </div>
  );
}

export type OverviewRowAccordionProps = Row & {
  id: string;
  t: (value?: any) => string;
} & ({ content: Renderable } | { rows: Row[] });

function OverviewRowAccordion_(props: OverviewRowAccordionProps) {
  const { id, content, accordionItemProps } = props;
  return (
    <AccordionItem
      value={accordionItemProps?.value ?? id}
      className={accordionItemStyles({
        ...props,
        className: props?.accordionItemProps?.className,
      })}
      {...accordionItemProps}
    >
      <AccordionTrigger>
        <OverviewRowBase_
          {...props}
          labelProps={{ ...props.valueProps, className: cn("mr-8") }}
        />
        {/* <OverviewRowBase_ {...props} /> */}
      </AccordionTrigger>
      <AccordionContent>
        {content ? render(content) : <OverviewRows {...props} />}
      </AccordionContent>
    </AccordionItem>
  );
}

function OverviewRow(props: Row & { id: string; t: (value?: any) => string }) {
  if (props.content || props.rows) {
    return <OverviewRowAccordion_ {...(props as OverviewRowAccordionProps)} />;
  }
  return <OverviewRowBase_ {...props} />;
}

function OverviewAccordion_(props: Row & { children?: ReactNode }) {
  // const { useValue } = useOverviewAccordionValues();
  // const { value, onValueChange } = useValue(
  //   (props.id ?? props._key ?? props?.index) as string,
  // );
  return (
    <Accordion
      // value={value as any}
      // onValueChange={onValueChange as any}
      {...props.accordionProps!}
      className={accordionStyles({
        ...props,
        isEven: props?.isEven ?? even(props),
        isEvenDepth: props?.isEvenDepth ?? evenDepth(props),
        hasParent: props.parent !== undefined,
        className: props.accordionProps?.className,
        siblingsAreAccordions: props?.siblingsAreAccordions,
      })}
    >
      {props?.children}
    </Accordion>
  );
}

function OverviewRows(props: Row) {
  const t = props?.parent?.t ?? props.t ?? ((a: any) => a as string);
  const { rows, ..._current } = props;
  const current = {
    ..._current,
    t,
    id: (props.id ?? props._key ?? props?.index) as string,
  };
  // const { state } = useOverviewAccordionValues();
  let accordionsCount = 0;
  const accordions = (rows ?? []).map((row, i) => {
    const isAccordion = (row.rows?.length ?? 0) > 0;
    if (isAccordion) {
      accordionsCount += 1;
    }
    return isAccordion;
  });
  let swap = false;
  let c = 0;
  const content =
    props?.content ??
    rows?.map((row, index) => {
      const _key =
        row?._key ??
        (typeof row?.label == "string" || typeof row?.label == "number"
          ? row.label
          : undefined) ??
        index;
      const path = [...(current?.path ?? []), _key];
      const depth = current?.depth !== undefined ? current.depth + 1 : 0;
      const id = `${current?.id ? `${current.id}.` : ""}${_key}`;
      const prevRow = rows?.[index - 1];
      const prevIsAccordion = (prevRow?.rows?.length ?? 0) > 0;
      const nextRow = rows?.[index + 1];
      const nextIsAccordion = (nextRow?.rows?.length ?? 0) > 0;
      const isAccordion = accordions?.[index] ?? false;
      const isEven = props?.isEven ?? even(props);
      if (!isAccordion) {
        c += 1;
      } else {
        if (c > 1 && c % 2 == 0) {
          swap = !swap;
        }
        c = 0;
      }
      const hasAccordions = !isAccordion && accordionsCount > 0;
      const itemsInRows =
        props?.itemsInRows ??
        (row.label || row.label === 0 ? 1 : 0) +
          (isDefined(row.value) ? asArray(row.value).length : 0);
      const siblingsAreAccordions = prevIsAccordion && nextIsAccordion;
      const invert =
        swap && !siblingsAreAccordions ? !props.invert : props.invert;
      const wrapClassName = isAccordion
        ? accordionWrapStyles({
            ...props,
            ...row,
            isEven: index % 2 === 0,
            isEvenDepth: depth % 2 == 0,
            siblingsAreAccordions,
            // invert: props.invert,
          })
        : undefined;

      // The legacy wrapper, kept as the default. Being defined inline it is a new component type on
      // every render, and React compares element types by identity - so a fresh type each render
      // unmounts and remounts every row's entire subtree, discarding any state inside it. `key`
      // cannot prevent that: keys only govern reordering among siblings, while a changed type always
      // remounts. `preserveRowState` swaps it for a plain conditional whose type is stable; see that
      // prop on Row for why the fix is opt-in rather than applied everywhere.
      const Wrap = isAccordion
        ? ({ children }) => <div className={wrapClassName}>{children}</div>
        : ({ children }) => children;

      const overviewRow = (
        <OverviewRow
          key={id}
          {..._.omit(props, "rows", "label", "value")}
          {...row}
          parent={current}
          index={index}
          id={id}
          path={path}
          depth={depth}
          _key={_key}
          t={t}
          invert={invert}
          siblingsAreAccordions={siblingsAreAccordions}
          rowProps={{
            ...row.rowProps,
            className: accordionRowsStyles({
              ...props,
              className: row?.rowProps?.className,
              itemsInRows: [2, 3].includes(itemsInRows)
                ? (itemsInRows as unknown as 2 | 3)
                : "auto",
              hasAccordions,
            }),
          }}
          accordionItemProps={{
            ...row?.accordionItemProps,
            className: nestedAccordionItemStyles({
              ...props,
              first: index === 0,
              last: index === (rows?.length ?? 0) - 1,
              // isEven,
              // isOpen,
              prevIsAccordion,
              nextIsAccordion,
              className: row?.accordionItemProps?.className,
              // invert,
            }),
          }}
        />
      );

      if (!props.preserveRowState) {
        return <Wrap key={id}>{overviewRow}</Wrap>;
      }

      return isAccordion ? (
        <div key={id} className={wrapClassName}>
          {overviewRow}
        </div>
      ) : (
        overviewRow
      );
    });

  return <OverviewAccordion_ {...props}>{render(content)}</OverviewAccordion_>;
}

function Overview_({ expandable, ...props }: Row) {
  const _key =
    props?._key ??
    (typeof props?.label == "string" || typeof props?.label == "number"
      ? props.label
      : undefined) ??
    "root";
  const path = [_key];
  const id = props?.id ?? `${_key}`;
  const t = props?.parent?.t ?? props.t ?? ((a: any) => a as string);
  const index = props?.index ?? 0;
  const next = { ...props, id, path, index, t, _key };
  if (expandable) {
    if ((props.rows?.length ?? 0) > 0 || props?.content) {
      return (
        <OverviewAccordion_ {...next}>
          <OverviewRow {...next} />
        </OverviewAccordion_>
      );
    } else {
      return <OverviewRow {...next} />;
    }
  }

  return <OverviewRows {...next} />;
}

export const Overview: typeof Overview_ = (props) => (
  // <OverviewAccordionValuesProvider {...props}>
  <Overview_ {...props} />
  /* </OverviewAccordionValuesProvider> */
);

// export const useOverviewAccordionValuesState = (props: Row) => {
//   const [state, setState] = React.useState<
//     Record<string, undefined | string | string[]>
//   >({});
//   const useValue = React.useCallback(
//     (key: string) => ({
//       value: state[key],
//       onValueChange: (a: React.SetStateAction<undefined | string | string[]>) =>
//         setState((s) => ({ ...s, [key]: functionalUpdate(a, s[key]) })),
//     }),
//     [state, setState],
//   );
//   // const flattened = React.useMemo(() => props.rows);
//   return { state, setState, useValue };
// };

// type OverviewAccordionValues = ReturnType<
//   typeof useOverviewAccordionValuesState
// >;

// export const OverviewAccordionValuesContext =
//   React.createContext<OverviewAccordionValues>(
//     undefined as unknown as OverviewAccordionValues,
//   );

// export function OverviewAccordionValuesProvider({
//   children,
//   ...props
// }: Row & {
//   children?: React.ReactNode;
// }) {
//   return (
//     <OverviewAccordionValuesContext.Provider
//       value={useOverviewAccordionValuesState(props)}
//       children={children}
//     />
//   );
// }

// export function useOverviewAccordionValues() {
//   return React.useContext(OverviewAccordionValuesContext);
// }
